<template>
<v-container fluid>
    <v-layout row wrap>
      <v-btn flat @click.native="goBack"><v-icon left>keyboard_backspace</v-icon>Вернуться</v-btn>
    </v-layout>
    <ClinicItem :clinic="clinicInfo"></ClinicItem>
</v-container>
</template>

<script>
import ClinicItem from '@/components/spravochnik/ClinicItem'

export default {
	props: ['id'],
	data() {
		return {}
	},
	computed: {
		clinicInfo() {
			return this.$store.getters.getClinicInfo(+this.id)
        }
	},
	methods: {
		fetchData(item) {
			this.clinicInfo = item
		},

		goBack() {
			return this.$router.go(-1)
		}
	},
	components: {
		ClinicItem
	}
}
</script>

<style>
.badge__badge {
	right: -60px;
}
</style>
